import { InvoiceDiscountType } from '../enums/invoiceDiscountType'
import type { InvoiceFormRowLine } from '../types/invoiceForm/invoiceFormLine/invoiceFormRowLine'
import { getSignedAmount } from './getSignedAmount'
import { InvoiceDiscountCalculator } from './invoiceDiscountCalculator'

interface CalculateRowLineTotalsOptions {
  currency: string
  discountType: InvoiceDiscountType
  isCreditNote?: boolean
  line: Pick<InvoiceFormRowLine, 'discount' | 'quantity' | 'unitPrice' | 'vatRatePercent'>
}

// Row line totals are always derived from unitPrice/quantity/discount/VAT through the calculation
// package, so the form never holds a total that the backend would compute differently.
export const calculateRowLineTotals = (
  options: CalculateRowLineTotalsOptions,
): Pick<InvoiceFormRowLine, 'totalExcludingVat' | 'totalIncludingVat'> => {
  const { currency, discountType, isCreditNote, line } = options
  const { totalExcludingVat, totalIncludingVat } = InvoiceDiscountCalculator.calculateLine(line, discountType, currency)

  return {
    totalExcludingVat: getSignedAmount(totalExcludingVat, isCreditNote),
    totalIncludingVat: getSignedAmount(totalIncludingVat, isCreditNote),
  }
}
